import client from '../base-api';

const serviceURL = '/office';

const officeService = {

    getOffices(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getOffice(officeId: number) {
        return client.get(`${serviceURL}/${officeId}`);
    },

    postOffice(officeData: any) {
        return client.post(`${serviceURL}`, officeData);
    },

    putOffice(officeData: any, officeId: number) {
        return client.put(`${serviceURL}/${officeId}`, officeData);
    },

    deleteOffice(officeId: number) {
        return client.delete(`${serviceURL}/delete/${officeId}`);
    },

    getExportOffice(officeId: number) {
        return client.get(`${serviceURL}/excel/export/${officeId}`);
    },
}

export default officeService;